<template>
    <div class="pd-12 top-border-bottom">
        <a class="exch-breadcrumb-heading-sec" @click="$router.go(-1)">
            <img  src="@/assets/images/back.webp" alt="back" >
            <h5 class="text-capitalize">Deposit</h5>
        </a>
    </div>
    <div class="exch-deposit-wrapper">
        <div class="mr-row-sec">
            <div class="multiSteps-container">
                <div class="multiSteps-points">
                    <div class="points-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 11 10" fill="none" class="w-3 h-3"><path d="M4.31258 7.43734L1.97925 5.104L2.42716 4.65609L4.31258 6.5415L8.31258 2.5415L8.7605 2.98942L4.31258 7.43734Z" fill="#E7EAEF" stroke="#E7EAEF" stroke-width="0.8"></path></svg>
                    </div>
                    <div class="points-border"></div>
                    <div class="points-circle active">2</div>
                    <div class="points-border"></div>
                    <div class="points-circle">3</div>
                    <div class="points-border"></div>
                    <div class="points-circle">4</div>
                </div>
                <div class="multiSteps-name">
                    <div class="title-wrap">{{ $t('enter-amt', 'Enter amount') }}</div>
                    <div class="title-wrap active">{{ $t('payment-method', 'Payment Method') }}</div>
                    <div class="title-wrap">{{ $t('make-deposit', 'Make Deposit') }}</div>
                    <div class="title-wrap">{{ $t('proof', 'Proof') }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="pd-12">
        <a class="exch-breadcrumb-heading-sec" @click="$router.go(-1)">
            <img  src="@/assets/images/back.webp" alt="back" >
            <h5 class="back-btn-bg">{{ $t('back-to-amount', 'Back To Amount') }}</h5>
        </a>
    </div>

    <div class="addPayment-methods">
        <div class="paymentMethods-bank depo-payment-bank-sec">
            <template v-for="(method, index) in paymentMethods" :key="index">
                
                <!-- <template v-for="bank in method?.banks" :key="bank.agent_bank_id"> -->
                    <div  class="paymentMethods-card" @click="choosePaymentMethod(method, method?.qr_code)">
                        <span class="paymentMethods-title">{{ index }}</span>
                        <div class="paymentMethods-body" :class="{paymentBonus: paymentBonus?.[method?.[0]?.method_id]}">
                            <div class="get-bonus-sec" v-if="paymentBonus?.[method?.[0]?.method_id]">Get {{ paymentBonus?.[method?.[0]?.method_id] }}% Bonus</div>
                            <div class="paymentMethods-icon">
                                <img loading="lazy" :src="methodIcons[index]" />
                            </div>
                            <span class="paymentMethods-text">{{ method[0]?.bank_name ? method[0]?.bank_name : method[0]?.account_holder_name  }} </span>
                        </div>
                        <div class="paymentMethods-footer" v-if="method[0]?.method === 'bank'">
                            <div class="paymentMethods-bank-wrap">
                                <div class="paymentMethods-bank-icon">
                                    <img src="@/assets/images/imps-footer.svg" alt="IMPS">
                                </div>
                                <div class="paymentMethods-bank-text">NEFT</div>
                                <div class="paymentMethods-bank-text">RTGS</div>
                            </div>
                        </div>
                        <div class="paymentMethods-footer" v-if="method[0]?.method === 'upi' || method[0]?.method === 'wallet'">
                            <div class="paymentMethods-upi-wrap">
                                <div class="paymentMethods-upi-icon">
                                    <img src="@/assets/images/google-pay.webp" alt="gPay">
                                </div>
                                <div class="paymentMethods-upi-icon">
                                    <img src="@/assets/images/phonepe-img.webp" alt="PhonePe">
                                </div>
                                <div class="paymentMethods-upi-icon">
                                    <img src="@/assets/images/bhim.webp" alt="BHIM">
                                </div>
                                <div class="paymentMethods-upi-icon">
                                    <img src="@/assets/images/paytm.webp" alt="Paytm">
                                </div>
                            </div>
                        </div>
                    </div>
            </template>
        </div>
        
    </div>
</template>

<script>
import { getParentPaymentsMethods } from '../services/depositPayment';
import { mapGetters } from 'vuex';
export default {
    name: "DepositPaymentMethod",
    inject: ['walletConfig'],
    computed: {
        ...mapGetters(['depositAmount','bonusData']),
        flatPaymentMethods() {
            return Object.values(this.paymentMethods).flat();
        },
        bankPaymentMethods() {
            return Array.isArray(this.paymentMethods)
            ? this.paymentMethods.filter(m => m?.method === 'bank')
            : [];
        },
        nonBankPaymentMethods() {
            return Array.isArray(this.paymentMethods)
            ? this.paymentMethods.filter(m => m?.method !== 'bank')
            : [];
        },
        methodIcons() {
            let iconObj = {};
            this.walletConfig?.payment_method?.forEach(element => {
                iconObj[element.method_name] = element.icon
            });
            this.walletConfig?.bank_list?.forEach(element => {
                iconObj[element.bank_name] = element.icon
            });
            return iconObj
        },
        paymentBonus() {
            if (!this.bonusData || !Array.isArray(this.bonusData)) {
                return {};
            }

            const paymentBonusData = this.bonusData?.filter(bd => bd.bonusType === 'payment bonus');

            if (paymentBonusData.length === 0) {
                return {};
            }

            return paymentBonusData.reduce((map, element) => {
                try {
                    const methodIds = JSON.parse(element.methodIds);
                    if (Array.isArray(methodIds)) {
                        methodIds.forEach(methodId => {
                            map[methodId] = element.percentage;
                        });
                    }
                } catch (error) {
                    console.warn('Failed to parse methodIds', error);
                }
                return map;
            }, {});
        }
    },
    data() {
        return {
            loading: false,
            paymentMethods: []
        }
    },
    mounted() {
        this.getParentPaymentsMethods();
    },
    methods: {
        gotoWhatsappDeposit() {
            window.open('https://wa.me/' + this.$siteSettings?.data?.social_link?.whatsappno1 || this.$siteSettings?.data?.social_link?.whatsappno2, '_blank')
        },
        async getParentPaymentsMethods(reconnectTry = 0){
            try {
                let response = await getParentPaymentsMethods( reconnectTry, this.depositAmount );
                if(response?.data){
                    this.paymentMethods = response?.data;
                }
            } catch (error) {
                if(reconnectTry < 3 && !error) {
                this.getParentPaymentsMethods(reconnectTry + 1);
            }
            else {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader',false);
                if (error) {
                    this.$router.back();
                    this.$errorToast(error[0]);
                }
            }
            }
        },

        choosePaymentMethod(payment, index){
            if (payment.qr_code) {
                payment.qrCodeUrl = qrCodeUrl;
            } else {
                payment.qrCodeUrl = null; // Handle cases where qr_code is null or undefined
            }
            if(payment?.[0]?.method == 'social'){
                const socialNumber = payment?.[0]?.social_payment_number;
                const socialLink = payment?.[0]?.social_payment_link;
                if (socialNumber?.length && socialLink?.length) {
                    const choice = Math.random() < 0.5 ? 'number' : 'link';
                    if (choice === 'number') {
                        if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                            window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                        } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                            window.open(`https://t.me/${socialNumber}`, 'blank');
                        }
                    } else {
                        window.open(socialLink, 'blank');
                    }
                    return;
                }
                if (socialNumber?.length) {
                    if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                        window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                    } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                        window.open(`https://t.me/${socialNumber}`, 'blank');
                    }
                    return;
                }
                if (socialLink?.length) {
                    window.open(socialLink, 'blank');
                    return;
                }
                this.$errorToast(this.$t('no-social-payment-number', 'No social payment number available'));
                return;
            };
            if(payment?.[0]?.method == 'payment_gateway'){
                this.isPaymentGateway = true;
                this.$store.dispatch('setDepositPaymentMethodData', {'data': payment, 'paymentgateway' : this.isPaymentGateway});
                this.$router.push({ name: 'make-deposit' });
                return
            }
            this.isPaymentGateway = false;
            this.$store.dispatch('setDepositPaymentMethodData', {'data': payment, 'paymentgateway' : this.isPaymentGateway});
            this.$router.push({ name: 'make-deposit' });
        },
    }
}
</script>